import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Impressum() {
    return (
        <LegalLayout title="Impressum" updated="Stand: Juli 2026" testid="impressum-page">
            <LegalSection title="Angaben gemäß § 5 DDG" testid="impressum-section-provider">
                <p>
                    Kirenzo
                    <br />
                    Inhaber: Wassim Acharkaoui
                    <br />
                    Kleine Steinstr. 14
                    <br />
                    45128 Essen
                    <br />
                    Deutschland
                </p>
            </LegalSection>
            <LegalSection title="Vertretung" testid="impressum-section-representation">
                <p>Vertreten durch den Inhaber: Wassim Acharkaoui</p>
            </LegalSection>
            <LegalSection title="Kontakt" testid="impressum-section-contact">
                <p>
                    E-Mail:{" "}
                    <a href="mailto:info@kirenzo.de" className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4">
                        info@kirenzo.de
                    </a>
                    <br />
                    Telefon:{" "}
                    <a href="tel:+4917646538303" data-testid="impressum-phone-link" className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4">
                        +49 176 46538303
                    </a>
                </p>
            </LegalSection>
            <LegalSection title="Registereintrag" testid="impressum-section-register">
                <p>
                    Kirenzo ist ein Einzelunternehmen; ein Handelsregistereintrag besteht daher nicht.
                </p>
            </LegalSection>
            <LegalSection title="Verantwortlich für den Inhalt" testid="impressum-section-content">
                <p>
                    Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV: Wassim Acharkaoui, Kleine Steinstr. 14,
                    45128 Essen
                </p>
            </LegalSection>
            <LegalSection title="Streitbeilegung" testid="impressum-section-dispute">
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit.
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                    Verbraucherschlichtungsstelle teilzunehmen.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
